import './dashboard.css';
import './dashboardReclamos.css';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import DashboardSidebar from '../components/Dashboard/DashboardSidebar';
import ReclamosDocumentacion from '../components/DashboardReclamos/ReclamosDocumentacion';
import ReclamosEstadosInternos from '../components/DashboardReclamos/ReclamosEstadosInternos';
import ReclamosTabla from '../components/DashboardReclamos/ReclamosTabla';

const COUNTERS = [
  { key: 'total', label: 'Total Ingresados', value: null, icon: 'bi-clipboard-data-fill', colorClass: 'total' },
  { key: 'sincargar', label: 'Sin Cargar', value: 901, icon: 'bi-file-earmark', colorClass: 'sincargar' },
  { key: 'pendiente', label: 'Pend. Aprobación', value: 902, icon: 'bi-hourglass-split', colorClass: 'pendiente' },
  { key: 'devolucion', label: 'Devoluciones', value: 903, icon: 'bi-arrow-return-left', colorClass: 'devolucion' },
  { key: 'reingreso', label: 'Reingresos', value: 905, icon: 'bi-arrow-repeat', colorClass: 'reingreso' },
  { key: 'cargado', label: 'Cargados / Recibidos', value: 904, icon: 'bi-check2-all', colorClass: 'cargado' },
];

export default function DashboardReclamosPage() {
  const [cookies] = useCookies(['user']);
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState(null);
  const [carpetaFilter, setCarpetaFilter] = useState(null); // null = all, 1 = SI, 0 = NO
  const [docFilter, setDocFilter] = useState(null); // null = all, 0 = sin doc, 1 = parcial, 2 = completa

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          'https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/solicitudesEstadoDoc2026'
        );
        setSolicitudes(res.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching solicitudes:', error);
        setLoading(false);
      }
    };
    if (cookies.user) {
      fetchData();
    }
  }, [cookies.user]);

  // Filter by user permissions (Rosario)
  const codigosA = cookies?.user?.codigosPermitidos;
  let allData = solicitudes;
  if (cookies.user?.id === 100 && codigosA) {
    const codigosANumeros = codigosA.split(',').map(c => Number(c.trim()));
    allData = solicitudes.filter(s => codigosANumeros.includes(s.codp));
  }

  // FILTERED DATA — apply ALL filters together
  let tableData = allData;

  // 1) Filter by estado
  if (activeFilter !== null && activeFilter !== undefined) {
    // eslint-disable-next-line
    tableData = tableData.filter(d => d.estado == activeFilter);
  }

  // 2) Filter by carpeta armada
  if (carpetaFilter !== null) {
    if (carpetaFilter === 1) {
      // eslint-disable-next-line
      tableData = tableData.filter(d => d.docOffice == 1);
    } else {
      tableData = tableData.filter(d => !d.docOffice || d.docOffice == 0); // eslint-disable-line
    }
  }

  // 3) Filter by estado documentacion
  if (docFilter !== null) {
    if (docFilter === 0) {
      tableData = tableData.filter(d => d.estadoDoc == 0 || d.estadoDoc === null || d.estadoDoc === undefined); // eslint-disable-line
    } else {
      tableData = tableData.filter(d => d.estadoDoc == docFilter); // eslint-disable-line
    }
  }

  const usuario = cookies.user?.usuario;

  const formatToday = () => {
    return new Date().toLocaleDateString('es-AR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  const handleFilterClick = (value) => {
    setActiveFilter(prev => (prev === value ? null : value));
  };

  const handleCarpetaFilter = (value) => {
    setCarpetaFilter(prev => (prev === value ? null : value));
  };

  const handleDocFilter = (value) => {
    setDocFilter(prev => (prev === value ? null : value));
  };

  // eslint-disable-next-line
  const getCount = (estadoValue) => estadoValue === null ? allData.length : allData.filter(d => d.estado == estadoValue).length;

  if (loading) {
    return (
      <div className='dashboard-loading'>
        <div className='dashboard-loading-spinner'></div>
        <p>Cargando dashboard de reclamos...</p>
      </div>
    );
  }

  return (
    <div className='dashboard-layout'>
      <DashboardSidebar user={cookies.user} />

      <main className='dashboard-main'>
        <div className='dashboard-header'>
          <div className='dashboard-header-left'>
            <h1>Dashboard Reclamos</h1>
            <p>
              Seguimiento integral de reclamos de terceros. Hola, {usuario}.
            </p>
          </div>
          <div className='dashboard-header-right'>
            <div className='dashboard-date-badge'>
              <i className='bi bi-calendar3'></i>
              {formatToday()}
            </div>
          </div>
        </div>

        {/* Counters — single unified row */}
        <div className='reclamos-counters-row'>
          {COUNTERS.map(c => {
            const count = getCount(c.value);
            const isActive = activeFilter === c.value;
            return (
              <button
                key={c.key}
                className={`reclamos-counter reclamos-counter--${c.colorClass} ${isActive ? 'reclamos-counter--active' : ''}`}
                onClick={() => handleFilterClick(c.value)}
              >
                <div className='reclamos-counter-count'>{count}</div>
                <div className='reclamos-counter-label'>{c.label}</div>
                <div className={`reclamos-counter-icon reclamos-counter-icon--${c.colorClass}`}>
                  <i className={`bi ${c.icon}`}></i>
                </div>
              </button>
            );
          })}
        </div>

        {/* Active filters indicator */}
        {(carpetaFilter !== null || docFilter !== null) && (
          <div className='reclamos-active-filters'>
            <span className='reclamos-active-filters-label'>
              <i className='bi bi-funnel-fill'></i> Filtros activos:
            </span>
            {carpetaFilter !== null && (
              <span className='reclamos-active-filter-tag' onClick={() => setCarpetaFilter(null)}>
                Carpeta: {carpetaFilter === 1 ? 'SI' : 'NO'}
                <i className='bi bi-x'></i>
              </span>
            )}
            {docFilter !== null && (
              <span className='reclamos-active-filter-tag' onClick={() => setDocFilter(null)}>
                Doc: {docFilter === 0 ? 'Sin Doc' : docFilter === 1 ? 'Parcial' : 'Completa'}
                <i className='bi bi-x'></i>
              </span>
            )}
            <button className='reclamos-clear-filters' onClick={() => { setCarpetaFilter(null); setDocFilter(null); setActiveFilter(null); }}>
              Limpiar todo
            </button>
          </div>
        )}

        {/* Content grid: Table + Documentation */}
        <div className='reclamos-content-grid' style={{ marginTop: '20px' }}>
          <ReclamosTabla
            key={`${activeFilter}-${carpetaFilter}-${docFilter}`}
            solicitudes={tableData}
          />
          <ReclamosDocumentacion
            solicitudes={allData}
            carpetaFilter={carpetaFilter}
            onCarpetaFilter={handleCarpetaFilter}
            docFilter={docFilter}
            onDocFilter={handleDocFilter}
          />
        </div>

        {/* Estados internos (desplegable) */}
        <div style={{ marginTop: '28px' }}>
          <ReclamosEstadosInternos solicitudes={allData} />
        </div>
      </main>
    </div>
  );
}
